<template>
  <div v-if="show" class="payment-list">
    <h4>Invoices &amp; Receipts</h4>
    <div class="item" v-if="hgPayments.outstandingBalance > 0">
      <p class="payment-text">
        You have an outstanding balance of
        {{currency(hgPayments.outstandingBalance)}}.
      </p>
      <template v-if="displayLinks">
        <router-link
          v-if="hgPayments.acceptsOnlinePayment"
          :to="paymentLink"
          class="btn-tertiary payment-link">
          View &amp; pay invoice(s)
        </router-link>
        <router-link
          v-else
          :to="invoiceLink"
          class="btn-tertiary payment-link">
          View invoice(s)
        </router-link>
      </template>
    </div>
    <div v-if="hgPayments.payments.length > 0">
      <div class="item" v-for="payment in hgPayments.payments" :key="`payment_${payment.id}`">
        <p class="payment-text">
          Thank you for your payment of
          {{currency(payment.amount)}} on
          {{dotDate(payment.datePaid)}}.
        </p>

        <router-link :to="receiptLink(payment.id)" class="btn-tertiary payment-link">
          View receipt
        </router-link>
      </div>
    </div>
    <div class="item" v-if="hgPayments.invoiceDocuments.length > 0">
      <h5>Individual invoice documents</h5>
      <a
        v-for="document in hgPayments.invoiceDocuments"
        :key="document.id"
        :href=document.link
        class="btn-tertiary document-link document-link">{{invoiceDocumentTitle(document)}}</a>
    </div>
  </div>
</template>

<script>
import { Mixins } from '@homegauge/vue';

const { CurrencyFilter, DateTime } = Mixins;

export default {
  props: {
    hgPayments: {
      type: Object,
      required: true,
    },
    hgFolderId: {
      type: String,
      required: true,
    },
    hgCompanyId: {
      type: Number,
      required: true,
    },
    hgFolderStatus: {
      type: Object,
      required: true,
    },
  },
  mixins: [CurrencyFilter, DateTime],
  computed: {
    show() {
      let show = false;
      if (this.hgPayments.payments.length > 0
        || this.hgPayments.invoiceDocuments.length > 0
        || this.hgPayments.outstandingBalance > 0) {
        show = true;
      }
      return show;
    },
    paymentLink() {
      return {
        name: 'payment',
        params: {
          companyId: this.hgCompanyId,
          folderId: this.hgFolderId,
        },
      };
    },
    invoiceLink() {
      return {
        name: 'invoice',
        params: {
          companyId: this.hgCompanyId,
          folderId: this.hgFolderId,
        },
      };
    },
    displayLinks() {
      return !this.hgFolderStatus.signatureNeeded;
    },
  },
  methods: {
    receiptLink(paymentId) {
      return {
        name: 'receipt',
        params: {
          companyId: this.hgCompanyId,
          folderId: this.hgFolderId,
          paymentId,
        },
      };
    },
    invoiceDocumentTitle(document) {
      return document.title || document.id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

a {
  display: block;
  margin-top: 10px;
}

p {
  margin: 0;
  padding: 0;
}

h4 {
  font-size: 1.143rem;
  color: $theme-color-gray;
}

h5,
.payment-text {
  color: rgba(0, 0, 0, 0.60);
  font-size: 1.143rem;
  font-weight: $typography-weight-normal;
}

.document-link {
  font-size: 1.071rem;
  margin-bottom: 0;
}

.payment-list {
  border-bottom: solid 1px rgba(0, 0, 0, 0.15);
  padding-bottom: 40px;
  padding-top: 40px;
}

.payment-link {
  font-size: 1.071rem;
}

.item {
  margin-top: 30px;

  &:nth-child(2) {
    margin-top: 20px
  }
}
</style>
